
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SelectFacet as DefaultSelectFacet,
} from '@uncinc/uncinc-react-kitchen-sink';
import { sortLabelsAscending, sortLabelsDescending } from '../../../helpers';

const BOLD_PREFIX_IDENTIFIER = 'Kies een';
const SECOND_BOLD_PREFIX_IDENTIFIER = 'Kies';

export const SelectFacet = (props) => {
  const { t } = useTranslation();
  const { facet } = props;
  const { identifier } = facet;

  const HOMEPAGE_PLACEHOLDERS = {
    field_workfield_name: t('placeholders.field_workfield_homepage.placeholder'),
    field_subject_name: t('placeholders.field_subject_homepage.placeholder'),
    field_type_of_information_name: t('placeholders.field_type_of_information_homepage.placeholder'),
    field_locations_name: t('placeholders.field_locations_name.placeholder'),
    field_phase_of_life_name: t('placeholders.field_phase_of_life_name.placeholder'),
  };

  const sortedEntries = [...facet.entries];
  if (facet.identifier === 'field_year') {
    sortedEntries.sort(sortLabelsDescending);
  } else {
    sortedEntries.sort(sortLabelsAscending);
  }

  const sortedFacet = { ...facet, entries: sortedEntries, isSearchable: false };

  // Convert the ID in a string to bold text.
  const convertTargetToBold = (el, id) => {
    const stringToReplace = el.split(id)[1];
    const stringToReplaceCapitalised = stringToReplace.charAt(1).toUpperCase() + stringToReplace.slice(2);
    const newValue = el.replace(stringToReplace, ` <b>${stringToReplaceCapitalised}</b>`);
    return newValue;
  };

  // Ensures that the identifier part of the label is displayed bold.
  useEffect(() => {
    const currentLabelElement = document.querySelector(`.Facet--${identifier} .Select__inner__placeholder`);
    const isHomepage = document.querySelector('.NodeHomePage__wizard');
    if (currentLabelElement) {
      const currentLabelElementValue = currentLabelElement.innerHTML;
      if (isHomepage) {
        currentLabelElement.innerHTML = HOMEPAGE_PLACEHOLDERS[identifier];
        return;
      }
      // Check if starts with the prefix identifier and replace the target words with a bold tag.
      if (currentLabelElementValue.startsWith(BOLD_PREFIX_IDENTIFIER)) {
        currentLabelElement.innerHTML = convertTargetToBold(currentLabelElementValue, BOLD_PREFIX_IDENTIFIER);
      } else if (currentLabelElementValue.startsWith(SECOND_BOLD_PREFIX_IDENTIFIER)) {
        currentLabelElement.innerHTML = convertTargetToBold(currentLabelElementValue, SECOND_BOLD_PREFIX_IDENTIFIER);
      }
    }
  }, [identifier, HOMEPAGE_PLACEHOLDERS]);

  return (
    <DefaultSelectFacet {...props} facet={sortedFacet} />
  );
};

SelectFacet.DISPLAY = 'SelectFacet';
